
import TimeSlotModel from './TimeSlotModel';

export default class CounselorAvailabilityModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.day = new Date(data.day);
    this.day_of_the_week = data.day_of_the_week || 0;

    this.morning_slots = (data.morning_slots || []).map(d => new TimeSlotModel(d));
    this.afternoon_slots = (data.afternoon_slots || []).map(d => new TimeSlotModel(d));
    this.evening_slots = (data.evening_slots || []).map(d => new TimeSlotModel(d));
  }
}
